module.exports = __webpack_public_path__ + "assets/img/f1ec1ba39aa91f31fa60811ccff9c927.png";